import { render, staticRenderFns } from "./product-shop-card.app.vue?vue&type=template&id=851831f4&"
import script from "./product-shop-card.app.vue?vue&type=script&lang=js&"
export * from "./product-shop-card.app.vue?vue&type=script&lang=js&"
import style0 from "./product-shop-card.app.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports